//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import vFooter from '../common/footer.vue'
    import {noticeDetail} from '@/base/js/api'   
    export default {
        name: 'app',
        data() {
            return {
                data:''
            }
        },
        created(){
            let params = {
                noticeId:this.$route.query.noticeId
            }
            noticeDetail(params).then(res=>{
                if(res.code == 0){
                    console.log(res);
                    this.data = res.data.notice

                }else{
                    this.$vux.toast.text(res.msg, 'middle')   
                }
            })
        },
        components: {
           vFooter 
        },
        methods: {
            share(){
                
            }
        }
    }



// WEBPACK FOOTER //
// ./src/pages/newDetail/newDetail.vue